import { Button, Errors, Form } from '@troon/ui';
import { createSignal, Switch, Match, createEffect } from 'solid-js';
import { Navigate, useLocation, useSubmission } from '@solidjs/router';
import { produce } from 'solid-js/store';
import { clientAction } from '@troon/api-client';
import { useTrackEvent } from '@troon/analytics';
import { useAuthStore } from '../flow';
import { SharedPasswordEntry } from './shared-password-entry';

export function ResetNewPassword() {
	const [store, setStore] = useAuthStore();
	const [valid, setValid] = createSignal(false);
	const location = useLocation();
	const trackEvent = useTrackEvent();

	const submission = useSubmission(resetPassword);

	createEffect(() => {
		if (submission.pending) {
			trackEvent('passwordReset');
		}
		if (submission.result) {
			setStore(
				produce((state) => {
					state.data = { email: state.data.email! };
					state.step = '/auth/login';
				}),
			);
		}
	});
	return (
		<Switch>
			<Match when={!store.data.email || !store.data.confirmationCode}>
				<Navigate href={`/auth${location.search}`} />
			</Match>

			<Match when={true}>
				<Form action={resetPassword} class="flex flex-col gap-4">
					<input name="emailOrRewardsId" type="hidden" value={store.data.email} />
					<input name="confirmationCode" type="hidden" value={store.data.confirmationCode} />

					<SharedPasswordEntry
						onUpdate={(valid) => {
							setValid(valid);
						}}
					/>

					<Errors />

					<Button type="submit" disabled={!valid()}>
						Set password
					</Button>
				</Form>
			</Match>
		</Switch>
	);
}

const resetPassword = clientAction('post', '/v0/auth/reset-password');
